import React from "react";

import {jsx} from '@emotion/react'
import { HashLink as Link } from 'react-router-hash-link';

export default function QuizAdd(props) {
  return (
    <div
      style={{
        margin: "30px 0px",
        boxShadow: "rgb(80 79 73 / 20%) 0px 6px 32px 0px",
      }}
    >
      <div className="d-lg-flex">
        <div style={{ flex: 1 }}>
          <div
            style={{ textAlign: "center" }}
            css={{
              paddingTop:40,
              paddingBottom:20,
              "@media (min-width:992px)":{
                margin:"30px 20px 30px 40px",
                padding:0,
              }
            }}
            className="thg_quiz_left_container"
          >
            <Link to="/shoe-reviews/quiz/">
              <img
                alt="Quiz"
                css={{
                  "@media (max-width:991px)":{
                    width:250
                  }
                }}
                src={`${__cdn__}/wp-content/uploads/2022/07/quiz1.png`}
              />
          </Link>
          </div>
        </div>
        <div
          className="thg_quiz_right_container"
          css={{
            padding:"10px 30px 40px 30px",

            "@media (min-width:992px)":{
              padding:30
            }
          }}
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <div
              style={{
                fontStyle: "italic",
                fontFamily: '"Montserrat", sans-serif',
                fontSize: "35px",
                fontWeight: 700,
                lineHeight: "1.3",
              }}
            >
              It's Quiz Time!
            </div>
            <div
              style={{
                fontSize: "16px",
                marginTop: "10px",
                marginBottom: "30px",
              }}
            >
              Answer 6 easy questions and find <br />
              your perfect basketball shoes!
            </div>
            <Link to="/shoe-reviews/quiz/">
              <span
                className="button"
                style={{ backgroundColor: "rgb(255,90,95)", fontWeight: 700 }}
              >
                Let's Get Started!
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
